export class SystemaktivitetNotisTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        read: "Läs mer"
    };
}
